import { combineReducers } from "redux";
import authReducer from "./authReducer";
import contentsReducer from "./contentsReducer";
import urlsReducer from "./urlsReducer";

export default combineReducers({
    auth: authReducer,
    contents: contentsReducer,
    urls: urlsReducer
})